export const BUTTON_1 = require('./button_1.png'); 
export const BUTTON_2 = require('./button_2.png'); 
export const BUTTON_3 = require('./button_3.png'); 
export const BUTTON_4 = require('./button_4.png'); 
export const BUTTON_5 = require('./button_5.png'); 
export const DOWNLOAD_BACKGROUND = require('./download_bg.png'); 
export const ICON_1 = require('./icon_1.png'); 
export const ICON_2 = require('./icon_2.png'); 
